import { Box, Button } from '@mui/material';
import React from 'react';

import './CommonButton.scss';

const CommonButton = (props) => {
  const {
    name,
    type,
    disabled,
    outline,
    onClick,
    btnSize,
    btnColor,
    btnClass,
    iconPlace,
    iconType,
  } = props;

  let buttonClass = '';

  const tempArray = [];
  if (disabled) {
    tempArray.push('disabled-btn');
  }

  if (outline) {
    tempArray.push('outline-btn');
  }

  if (btnSize !== '') {
    tempArray.push(btnSize);
  }

  if (btnColor !== '') {
    tempArray.push(btnColor);
  }

  if (btnClass?.length > 0) {
    buttonClass = tempArray.push(btnClass);
  }

  if (tempArray?.length > 0) {
    buttonClass = tempArray.join(' ');
  }

  const iconDisplay = (icon) => {
    switch (icon) {
      default:
        return icon;
    }
  };

  return (
    <Box className="customButton">
      <Button
        variant="contained"
        type={type}
        className={`Button normal-btn  ${buttonClass}`}
        disabled={disabled}
        onClick={onClick}
      >
        {iconPlace === 'front' && (
          <Box className={`pr10`}>
            <span className={`colorWhite fw400 font20 justifyCenter`}>
              {iconDisplay(iconType)}
            </span>
          </Box>
        )}
        <span className={`colorWhite fw600 `}>{name}</span>

        {iconPlace === 'back' && (
          <Box className={`colorWhite fw400 font20 ml10 justifyCenter`}>
            {iconDisplay(iconType)}
          </Box>
        )}
      </Button>
    </Box>
  );
};

export default CommonButton;
